/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_ErrorInputs */

const es_chat_tool_detail_error = /** @type {(inputs: Chat_Tool_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const en_chat_tool_detail_error = /** @type {(inputs: Chat_Tool_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Chat_Tool_Detail_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_error = /** @type {((inputs?: Chat_Tool_Detail_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_error(inputs)
	return en_chat_tool_detail_error(inputs)
});
export { chat_tool_detail_error as "chat.tool_detail.error" }